import { doGet, doDownload, doPost } from "../base";

const DEVICE_EVENTS_URL = () => `user_auth/deviceEvents`;

const SET_DAFAULTS = ({ limit, page, sortField, sortOrder, serialNumber, triggeredAtStartDate, triggeredAtEndDate, event, patient, details }) => {
    let params = [];
    if (limit) {
        params.push("limit=" + limit);
    }
    if (page) {
        params.push("page=" + page);
    }
    if (sortField) {
        params.push("sortField=" + sortField);
    }
    if (sortOrder) {
        params.push("sortOrder=" + sortOrder);
    }
    if (serialNumber) {
        params.push("serialNumber=" + serialNumber)
    }
    if (triggeredAtStartDate) {
        params.push("triggeredAtStartDate=" + triggeredAtStartDate)
    }
    if (triggeredAtEndDate) {
        params.push("triggeredAtEndDate=" + triggeredAtEndDate)
    }
    if (event) {
        params.push("event=" + event)
    }
    if (patient) {
        params.push("patient=" + patient)
    }
    if (details) {
        params.push("details=" + details)
    }
    return params;
}

export const getDeviceEvents = async ({ limit, page, sortField, sortOrder, serialNumber, triggeredAtStartDate, triggeredAtEndDate, event, patient, details, isKarieDUO }) => {
    let url = DEVICE_EVENTS_URL();

    let params = SET_DAFAULTS({limit, page, sortField, sortOrder, serialNumber, triggeredAtStartDate, triggeredAtEndDate, event, patient, details});
    isKarieDUO ? params.push("deviceType=karieDUO") : params.push("deviceType=karie")
    for (let i=0; i < params.length; i++) {
        url += i > 0 ? "&" + params[i] : "?" + params[i];
    }
    return await doGet(url).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    });
}

export const fetchAllEventTypes = async ({isKarieDUO}) => {
    var url = DEVICE_EVENTS_URL();

    url += "/event_types";
    isKarieDUO ? url += "?" + "deviceType=karieDUO" : url += "?" + "deviceType=karie"
    return await doGet(url).catch((error) => {
        throw error;
    });
};
